import { useController } from "react-hook-form";
import cns from "classnames";
import { Box, Typography, makeStyles } from "@material-ui/core";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import locale from "@bonliva-crm/locale";
import { Color } from "@bonliva-crm/ui";
import { FilterWithFavouriteProps } from "../utils/filters-record-types";
import { NonCollapsibleFavFilter } from "./_base/non-collapsible-fav-filter";

export type HasDrivingLicenseFilterProps = FilterWithFavouriteProps;

export const HasDrivingLicenseFilter = (props: HasDrivingLicenseFilterProps) => {
  const classes = useStyles();
  const title = props.label ?? locale.HasDrivingLicence;
  const { field, fieldState } = useController({ name: props.name });

  if (props.setFavorite) {
    return (
      <NonCollapsibleFavFilter
        title={title}
        isDirty={fieldState.isDirty}
        isClearable={false}
        action={
          <Box pr={1}>
            <ToggleButtonGroup
              value={field?.value}
              exclusive
              onChange={(e, v) => field.onChange(v)}
            >
              <ToggleButton value="none">{locale.All}</ToggleButton>
              <ToggleButton value="auto">B&nbsp;auto</ToggleButton>
              <ToggleButton value="all">&nbsp;&nbsp;B&nbsp;&nbsp;</ToggleButton>
            </ToggleButtonGroup>
          </Box>
        }
        favorite={props.favorite}
        onSetFavorite={props.setFavorite}
      />
    );
  }

  return (
    <span className={cns(classes.root, classes.border)}>
      <Typography variant="body1" style={{ color: Color.DetailsInput }}>
        {locale.HasDrivingLicence}
      </Typography>

      <div>
        <ToggleButtonGroup
          size="small"
          value={field?.value}
          exclusive
          onChange={(e, v) => field.onChange(v)}
        >
          <ToggleButton value="none">{locale.All}</ToggleButton>
          <ToggleButton value="auto">B&nbsp;auto</ToggleButton>
          <ToggleButton value="all">&nbsp;&nbsp;B&nbsp;&nbsp;</ToggleButton>
        </ToggleButtonGroup>
      </div>
    </span>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(1),
    gap: "0.5rem"
  },
  border: {
    border: `1px solid ${Color.LightGray}`,
    borderRadius: "4px"
  }
}));
